import { useRef } from 'react';
import { HomefieldIconListMenu } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from '../../../../../utility/constants';
import MenuPopover, { useMenuPopover } from '../../MenuPopover/MenuPopover';

interface HamburgerMenuProps {
  setShowDrawer: () => void;
  viewPortBreakpoint: string;
  viewTopNavAnalyticsEventHandler: () => void;
  progressiveHeaderEnabled: boolean;
}

const HamburgerMenu = ({
  setShowDrawer,
  viewPortBreakpoint,
  viewTopNavAnalyticsEventHandler,
  progressiveHeaderEnabled,
}: HamburgerMenuProps) => {
  const hamburgerMenuRef = useRef(null);
  const { showMenuPopoverFlag, newTaxoPopoverClosed, taxoPopOverHasBeenClosed } = useMenuPopover();

  const hamburgerMenuEventHandler = () => {
    setShowDrawer();
    viewTopNavAnalyticsEventHandler();
    taxoPopOverHasBeenClosed();
  };

  return (
    <div
      ref={hamburgerMenuRef}
      className="hamburger-menu hmf-display-flex hmf-flex-col hmf-align-items-center hmf-pr-xs hmf-pl-xlg-xs hmf-pr-xlg-0 hmf-pb-md-s hmf-pb-xlg-0">
      <button
        className="hamburger-icon hmf-display-flex hmf-flex-column hmf-align-items-center hmf-p-xxs hmf-pt-xlg-0"
        onClick={() => hamburgerMenuEventHandler()}
        onKeyDown={(event) => {
          if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
            hamburgerMenuEventHandler();
          }
        }}
        tabIndex={0}
        type="button"
        aria-label="Open menu">
        <HomefieldIconListMenu aria-label="Open menu icon" />
        <div className="hmf-subheader-s hmf-subheader-bold-lg-m hamburger-text">
          {viewPortBreakpoint !== 'mobile' ? 'Shop' : 'Menu'}
        </div>
      </button>
      {showMenuPopoverFlag && progressiveHeaderEnabled && !newTaxoPopoverClosed && (
        <MenuPopover hamburgerMenuRef={hamburgerMenuRef} component="hamburgerMenu" />
      )}
    </div>
  );
};

export default HamburgerMenu;
